import axios from "axios";

interface TemplateResponse {
  url: string;
}

export const getFacilitiesTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/facilities`);
  return data.url;
};

export const getUtilitiesTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/utilities`);
  return data.url;
};

export const getLogisticsPackaging = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/logistics_packaging`);
  return data.url;
};

export const getBulkLogisticsPackaging = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/bulk_logistics_packaging`);
  return data.url;
};

export const getPurchaseOrdersTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/purchase_orders`);
  return data.url;
};

export const getInboundTransportTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/transport_inbound`);
  return data.url;
};

export const getOutboundTransportTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/transport_outbound`);
  return data.url;
};

export const getSalesOrdersTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/sales_orders`);
  return data.url;
};

export const getBomTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/products_materials`);
  return data.url;
};

export const getProductDetailsTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/product_details`);
  return data.url;
};

export const getProductPackagingTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/packaging`);
  return data.url;
};

export const getFacilityGoodsAndServicesTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/facility_goods_and_services`);
  return data.url;
};

export const getGoodsAndServicesTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/goods_and_services`);
  return data.url;
};

export const getEmployeeCommuteTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/employee_commute`);
  return data.url;
};

export const getEmployeeBusinessTravelTemplate = async (): Promise<string> => {
  const { data } = await axios.get<TemplateResponse>(`/template/employee_business_travel`);
  return data.url;
};
